/**
 * @generated SignedSource<<cca09b170ab2d2818122119c2cf83406>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FooterRenderer_rank$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreateFooter_rankField">;
  readonly " $fragmentType": "FooterRenderer_rank";
};
export type FooterRenderer_rank$key = {
  readonly " $data"?: FooterRenderer_rank$data;
  readonly " $fragmentSpreads": FragmentRefs<"FooterRenderer_rank">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FooterRenderer_rank",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueCreateFooter_rankField"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "1a295e01caab47d2d434a50b4c74845e";

export default node;
